// extracted by mini-css-extract-plugin
export default {"SkillsCollection":"SkillsCollection_SkillsCollection__L1x0I"};